import axios from "axios";

const CLOUD_NAME = import.meta.env.VITE_CLOUDINARY_CLOUD_NAME;
const VIDEO_PRESET = import.meta.env.VITE_CLOUDINARY_VIDEO_PRESET;

export interface CloudinaryUploadResult {
  url: string;
  public_id: string;
  duration?: number;
  format?: string;
  bytes?: number;
}

/**
 * Upload video TRỰC TIẾP từ browser lên Cloudinary (unsigned preset).
 * Không qua server → bỏ giới hạn nginx/timeout, không tốn RAM VPS.
 */
export const uploadVideoToCloudinary = async (
  file: File,
  onProgress?: (percent: number) => void,
): Promise<CloudinaryUploadResult> => {
  if (!CLOUD_NAME || !VIDEO_PRESET) {
    throw new Error(
      "Thiếu cấu hình Cloudinary. Kiểm tra VITE_CLOUDINARY_CLOUD_NAME và VITE_CLOUDINARY_VIDEO_PRESET.",
    );
  }

  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_preset", VIDEO_PRESET);

  const res = await axios.post(
    `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/video/upload`,
    formData,
    {
      // Không gửi cookie/auth của app sang Cloudinary
      withCredentials: false,
      onUploadProgress: (e) => {
        if (onProgress && e.total) {
          onProgress(Math.round((e.loaded / e.total) * 100));
        }
      },
    },
  );

  return {
    url: res.data.secure_url,
    public_id: res.data.public_id,
    duration: res.data.duration,
    format: res.data.format,
    bytes: res.data.bytes,
  };
};
